import { render, staticRenderFns } from "./answerRecord.vue?vue&type=template&id=2212ad40&scoped=true"
import script from "./answerRecord.vue?vue&type=script&lang=js"
export * from "./answerRecord.vue?vue&type=script&lang=js"
import style0 from "./answerRecord.vue?vue&type=style&index=0&id=2212ad40&prod&lang=less&scoped=true"
import style1 from "./answerRecord.vue?vue&type=style&index=1&id=2212ad40&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2212ad40",
  null
  
)

export default component.exports